var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlusSquare = function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.333 3.167a.667.667 0 0 0-.667.666v9.334c0 .368.299.666.667.666h9.333a.667.667 0 0 0 .667-.666V3.833a.667.667 0 0 0-.667-.666H3.333Zm-2 .666a2 2 0 0 1 2-2h9.333a2 2 0 0 1 2 2v9.334a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2V3.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.167c.368 0 .666.298.666.666v5.334a.667.667 0 1 1-1.333 0V5.833c0-.368.298-.666.667-.666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.667 8.5c0-.368.298-.667.667-.667h5.333a.667.667 0 1 1 0 1.334H5.334a.667.667 0 0 1-.667-.667Z"
  })));
};

export default SvgPlusSquare;